module.exports = __webpack_public_path__ + "static/img/route_recording_disable.fa033568.svg";